import AgentDetails from './agent-details';

export default AgentDetails;
